const STORAGE_KEY = 'vantag-privy-pending-auth';

/** 登出 / 取消：清掉未完成的托管补绑材料，避免下一账号误续跑 */
export function clearPrivyPendingAuth() {
  if (typeof sessionStorage === 'undefined') return;
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

/**
 * Google OAuth 回调后暂存签名凭证，回到首页在 AuthDialog 内继续授权。
 * @param {{ prepared: object, signerHint?: string, inviteCode?: string, returnStep?: string, originLoginType?: string, email?: string }} payload
 */
export function storePrivyPendingAuth({
  prepared,
  signerHint = '',
  inviteCode = '',
  returnStep = 'select',
  originLoginType = '',
  email = '',
} = {}) {
  if (typeof sessionStorage === 'undefined' || !prepared) return;

  const origin = String(originLoginType || prepared.originLoginType || '')
    .trim()
    .toUpperCase();
  const resolvedEmail = String(email || prepared.email || '').trim();

  sessionStorage.setItem(
    STORAGE_KEY,
    JSON.stringify({
      address: String(prepared.address ?? '').trim(),
      privyWalletId: String(prepared.privyWalletId ?? '').trim(),
      walletAddress: String(prepared.walletAddress ?? '').trim(),
      signature: String(prepared.signature ?? '').trim(),
      message: String(prepared.message ?? '').trim(),
      signerHint: String(signerHint ?? '').trim(),
      inviteCode: String(inviteCode ?? prepared.inviteCode ?? '').trim(),
      originLoginType: origin,
      email: origin === 'EMAIL' || origin === 'GOOGLE' ? resolvedEmail : '',
      returnStep:
        returnStep === 'email' || returnStep === 'email-verify' ? 'email-verify' : 'select',
    })
  );
}
/** @returns {ReturnType<typeof storePrivyPendingAuth> extends void ? object|null : object|null} */
export function consumePrivyPendingAuth() {
  if (typeof sessionStorage === 'undefined') return null;
  const raw = sessionStorage.getItem(STORAGE_KEY);
  sessionStorage.removeItem(STORAGE_KEY);
  if (!raw) return null;

  try {
    const data = JSON.parse(raw);
    if (!data?.address || !data?.privyWalletId) {
      return null;
    }
    const origin = String(data?.originLoginType ?? '')
      .trim()
      .toUpperCase();
    const custodialOrigin = origin === 'EMAIL' || origin === 'GOOGLE';
    // 邮箱/Google 主路径不再生成 login/wallet 验签材料；仅托管登记需要 address + privyWalletId
    if (!custodialOrigin && (!data?.signature || !data?.message)) {
      return null;
    }
    return data;
  } catch {
    return null;
  }
}
